import React from "react"

import HeroSectionDesktop from "./HeroSectionDesktop"
import HeroSectionMobile from "./HeroSectionMobile"

const HeroSection = ({ section, practice, theme, highlightedField, viewMode = "", deviceType = "desktop" }) => {
  // If viewMode is explicitly set (from preview), use that to determine which component to show
  if (viewMode === "mobile") {
    return <HeroSectionMobile section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
  }

  if (viewMode === "desktop") {
    return (
      <HeroSectionDesktop section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  // Use server-side device detection for public pages
  if (deviceType === "mobile") {
    return <HeroSectionMobile section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
  }

  // Default to desktop for desktop devices
  return <HeroSectionDesktop section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
}

export default HeroSection
